export default "__VITE_ASSET__5c01f228__"